module.exports = __webpack_public_path__ + "img/spin_btn.0491d2ec.png";